<template>
  <div>
    <ContentHeader title="Add Broker" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="broker-id">Broker</label>
                    <select
                      id="broker-id"
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.broker_id.$error,
                      }"
                      v-model="payload.broker_id"
                    >
                      <option
                        v-for="broker in brokers"
                        :key="broker.id"
                        :value="broker.id"
                      >
                        {{ broker.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="account-number">Account Number</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'border-danger':
                          ($v.payload.trader_password.$error &&
                            !$v.payload.account_number.required) ||
                          !$v.payload.account_number.numeric ||
                          account_number_error,
                      }"
                      id="account-number"
                      placeholder="Enter Account Number"
                      @input="setAccountNumber($event.target.value)"
                      :value="payload.account_number"
                    />
                    <div class="text-danger" v-if="account_number_error">
                      <small class="mb-0">
                        {{ account_number_error }}
                      </small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="
                        !$v.payload.account_number.required &&
                        $v.payload.trader_password.$error
                      "
                    >
                      <small>Account Number Required</small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="!$v.payload.account_number.numeric"
                    >
                      <small>This Field Must be Number</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="trader-password">Trader Password</label>
                    <div class="input-group">
                      <input
                        :type="show.password ? 'text' : 'password'"
                        class="form-control"
                        :class="{ 'border-danger': $v.payload.trader_password.$error }"
                        placeholder="Password"
                        v-model="payload.trader_password"
                      />
                      <div class="input-group-append">
                        <div
                          class="input-group-text"
                          :class="{ 'border-danger': $v.payload.trader_password.$error }"
                          @click="showPassword()"
                        >
                          <span
                            class="fas"
                            :class="{
                              'fa-eye': !show.password,
                              'fa-eye-slash': show.password,
                            }"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="$v.payload.trader_password.$error"
                    >
                      <small>Trader Password Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="broker-server">Broker Server</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'border-danger': $v.payload.broker_server.$error,
                      }"
                      id="broker-server"
                      placeholder="Enter Broker Server"
                      v-model="payload.broker_server"
                    />
                    <div
                      class="text-danger"
                      v-if="$v.payload.broker_server.$error"
                    >
                      <small>Broker Server Required</small>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <router-link
                    class="btn btn-outline-danger mr-3"
                    :to="{ name: 'RobotDetails' }"
                  >
                    Back
                  </router-link>
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiBroker from "@/services/BrokerApiServices";
import apiClient from "@/services/ApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      brokers: null,
      show: {
        password: false,
      },
      payload: {
        broker_id: 1,
        account_number: "",
        trader_password: "",
        broker_server: "",
      },
      account_number_error: "",
      submitStatus: null,
    };
  },

  validations: {
    payload: {
      broker_id: {
        required,
      },
      account_number: {
        required,
        numeric,
      },
      trader_password: {
        required,
      },
      broker_server: {
        required,
      },
    },
  },

  components: {
    ContentHeader,
  },

  async mounted() {
    try {
      let response = await apiBroker.get(`/`)
      this.brokers = response.data.data;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    }
  },

  methods: {
    showPassword() {
      this.show.password = !this.show.password;
    },
    setAccountNumber(value) {
      this.account_number_error = "";
      this.payload.account_number = value;
      this.$v.name.$touch();
    },
    async handleCreateData() {
      let data = new FormData();

      data.append("robot_id", this.$route.params.id);
      data.append("broker_id", this.payload.broker_id);
      data.append("account_number", this.payload.account_number);
      data.append("trader_password", this.payload.trader_password);
      data.append("broker_server", this.payload.broker_server);
      data.append("is_active", true);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        try {
          await apiClient.post("broker/", data);
          this.submitStatus = "OK";
          this.account_number_error = "";

          this.$swal("Added!", "New data has been added.", "success").then(
            () => {
              this.$router.push({
                name: "RobotDetails",
                params: { id: this.$route.params.id },
              });
            }
          );
        } catch (error) {
          this.submitStatus = "ERROR";
          this.account_number_error = error.data.data.account_number[0];
        }
      }
    },
  },
};
</script>
